interface FileListPayload {
  status?: string
  result?: { file_name?: unknown }[]
}

/**
 * @param payload fetchFileList payload (getFileInfo response)
 * @returns the server file names of the case, null when the list is unavailable
 */
export const getServerFileNames = (payload: unknown): string[] | null => {
  const { status, result } = (payload ?? {}) as FileListPayload
  if (status !== "Success" || !Array.isArray(result)) return null
  return result
    .map((file) => file?.file_name)
    .filter((name): name is string => typeof name === "string")
}

interface ZipResponse {
  data?: unknown
  request?: { responseURL?: unknown }
}

/**
 * @param responses fetchFileZips payload (one axios response per zip)
 * @returns the downloaded zips by file name ("bulk2.zip"), skipping malformed responses
 */
export const toZipRecord = (responses: unknown): Record<string, Blob> => {
  if (!Array.isArray(responses)) return {}
  const zips: Record<string, Blob> = {}
  for (const response of responses as ZipResponse[]) {
    const url = response?.request?.responseURL
    const fileName = typeof url === "string" ? url.split("/").pop() : undefined
    if (fileName && response.data instanceof Blob) {
      zips[fileName] = response.data
    }
  }
  return zips
}
